import { render, staticRenderFns } from "./PromoTemplateA7MSRManual.vue?vue&type=template&id=32fbdc92"
import script from "./PromoTemplateA7MSRManual.vue?vue&type=script&lang=js"
export * from "./PromoTemplateA7MSRManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports